import React, {Component} from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Layout
import Header from "../layout/header";
import Footer from "../layout/footer";
import { BookingStatusStepper } from "../elements/premium";

class ThankYou extends Component{
	
	render(){

		const { params = {} } = this.props.location.state || {};

		return (
			<div className="rr-thankyou rr-thankyou--lux">
				<Helmet>
					<meta name="robots" content="noindex, nofollow" />
				</Helmet>

				<Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} transparent={false} />
				
				<div className="page-content bg-white">
					
					<section className="rr-thankyou-hero">
						<div className="container">
							<div className="rr-thankyou-hero__content">
								<div className="rr-thankyou-success-icon">
									<svg width="80" height="80" viewBox="0 0 80 80" fill="none">
										<circle cx="40" cy="40" r="38" stroke="currentColor" strokeWidth="4"/>
										<path d="M25 40L35 50L55 30" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
								</div>
								<h1 className="rr-thankyou-title">Booking Confirmed!</h1>
								<p className="rr-thankyou-subtitle">
									Thank you, <strong>{params.first_name || 'valued customer'}</strong>! Your service is scheduled. We're looking forward to exceeding your expectations.
								</p>
							</div>
						</div>
					</section>
					
					<section className="rr-thankyou-details">
						<div className="container">
							<div className="row justify-content-center">
								<div className="col-lg-10 col-xl-8">

									{params.booking_id && (
										<div className="rr-thankyou-stepper">
											<h2 className="rr-detail-section__title">Your service journey</h2>
											<BookingStatusStepper bookingId={params.booking_id} />
										</div>
									)}

									<div className="rr-booking-card">
										<div className="rr-booking-card__header">
											<h2 className="rr-booking-card__title">Booking Details</h2>
											<div className="rr-booking-id">ID: <span>{params.booking_id}</span></div>
										</div>

										<div className="rr-booking-card__body">
											
											<div className="rr-detail-section">
												<h3 className="rr-detail-section__title">Contact Information</h3>
												<div className="rr-detail-grid">
													<div className="rr-detail-item">
														<span className="rr-detail-label">Name</span>
														<span className="rr-detail-value">{params.first_name} {params.last_name}</span>
													</div>
													<div className="rr-detail-item">
														<span className="rr-detail-label">Phone</span>
														<span className="rr-detail-value">{params.phone}</span>
													</div>
													<div className="rr-detail-item rr-detail-item--full">
														<span className="rr-detail-label">Email</span>
														<span className="rr-detail-value">{params.email}</span>
													</div>
												</div>
											</div>

											<div className="rr-detail-section">
												<h3 className="rr-detail-section__title">Service Details</h3>
												<div className="rr-detail-grid">
													<div className="rr-detail-item">
														<span className="rr-detail-label">Vehicle</span>
														<span className="rr-detail-value">{params.vehicle_name}</span>
													</div>
													<div className="rr-detail-item">
														<span className="rr-detail-label">Service Type</span>
														<span className="rr-detail-value">{params.service_type}</span>
													</div>
													<div className="rr-detail-item">
														<span className="rr-detail-label">Date</span>
														<span className="rr-detail-value">{params.date_of_service}</span>
													</div>
													<div className="rr-detail-item">
														<span className="rr-detail-label">Time</span>
														<span className="rr-detail-value">{params.time_of_service}</span>
													</div>
													<div className="rr-detail-item rr-detail-item--full">
														<span className="rr-detail-label">Address</span>
														<span className="rr-detail-value">{params.address}</span>
													</div>
													{params.additional_details && (
														<div className="rr-detail-item rr-detail-item--full">
															<span className="rr-detail-label">Additional Details</span>
															<span className="rr-detail-value">{params.additional_details}</span>
														</div>
													)}
												</div>
											</div>

											<div className="rr-detail-section">
												<h3 className="rr-detail-section__title">Payment Summary</h3>
												<div className="rr-payment-summary">
													<div className="rr-payment-row">
														<span className="rr-payment-label">Total Amount</span>
														<span className="rr-payment-value">₹{params.total_amount}</span>
													</div>
													<div className="rr-payment-row rr-payment-row--highlight">
														<span className="rr-payment-label">Advance Paid</span>
														<span className="rr-payment-value">₹{params.paid_amount || 0}</span>
													</div>
												</div>
											</div>

										</div>
									</div>

									<div className="rr-info-cards">
										<div className="rr-info-card rr-info-card--primary">
											<h4 className="rr-info-card__title">What's Next?</h4>
											<p className="rr-info-card__text">
												You will receive booking confirmation details via email and WhatsApp. Our expert mechanic will arrive at your location on the scheduled date and time.
											</p>
										</div>
										<div className="rr-info-card rr-info-card--secondary">
											<h4 className="rr-info-card__title">Important Notice</h4>
											<p className="rr-info-card__text">
												Please refrain from making any payment directly to our mechanics without receiving a proper invoice. Ride N Repair will not be held liable for any services or warranties for amounts paid without a valid invoice.
											</p>
										</div>
									</div>

									<div className="rr-thankyou-actions">
										<Link to="/" className="rr-btn rr-btn--primary">Back to Home</Link>
										<Link to="/booking" className="rr-btn rr-btn--secondary">Book Another Service</Link>
									</div>

								</div>
							</div>
						</div>
					</section>
				
				</div>
				
				<Footer setCitiesModal={this.props.setCitiesModal} />
				
			</div>
		);
	}
}

export default ThankYou;